import { useEffect, useMemo, useState } from "react";
import NavContentNavigation from "./components/NavContentNavigation/NavContentNavigation";
import { NavContentContext } from "./NavContent.context";
import type { NavContentProps } from "./NavContent.types";
import "./NavContent.css";

function getInitialSection(sections: string[], initialSection?: string) {
  const normalized = sections.map((s) => s.toLowerCase());
  return (
    normalized.find((s) => s.toLowerCase() === initialSection?.toLowerCase()) ??
    normalized[0] ??
    ""
  );
}

export default function NavContent({
  sections,
  initialSection,
  children,
  onSectionChange,
}: NavContentProps) {
  const [selectedSection, setSelectedSection] = useState(
    getInitialSection(sections, initialSection)
  );

  useEffect(() => {
    const normalized = sections.map((s) => s.toLowerCase());
    if (normalized.length > 0 && !normalized.includes(selectedSection)) {
      setSelectedSection(normalized[0]);
    }
  }, [sections, selectedSection]);

  useEffect(() => {
    onSectionChange?.(selectedSection);
  }, [selectedSection, onSectionChange]);

  const contextValue = useMemo(
    () => ({ sections, selectedSection, setSelectedSection }),
    [sections, selectedSection]
  );

  return (
    <NavContentContext value={contextValue}>
      <div className="flex flex-1 overflow-hidden h-full bg-background-default">
        <nav className="w-[220px] shrink-0 pt-3 overflow-auto border-r border-divider">
          <NavContentNavigation />
        </nav>
        <div className="nav-content-panel relative flex flex-1 flex-col overflow-hidden">
          {typeof children === "function" ? children(selectedSection) : children}
        </div>
      </div>
    </NavContentContext>
  );
}
